export enum OccupedStratalotPatchEnum {
  occupant = 'occupant',
  lots = 'lots'
}
